import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import ProgressButton from "../../ProgressButton";

const classes = {
    actionButton: css`
        display: inline-flex;
        min-height: 36px;
        margin-top: 10px;
        width: 100%;
    `,
};

const ButtonStartRun = (props) => {
    const { t } = useTranslation();

    const enabled =
        props.runName &&
        props.selectedSurveyDatabaseId &&
        props.selectedPopulationDatabaseId &&
        props.selectedCountryNumericCode &&
        props.selectedRunType &&
        (props.selectedRunType === "Subnational" && !props.selectedRegion ? false : true);

    return (
        <>
            <ProgressButton
                variant="contained"
                disabled={!enabled}
                loading={props.submittingRun}
                className={classes.actionButton}
                onClick={props.onStartRun}
            >
                {t("Start run")}
            </ProgressButton>
        </>
    );
};

export default ButtonStartRun;
